(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyra-similar-styles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cyra-similar-styles')) {
    customElements.define(
      'cyra-similar-styles',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.static === 'true' || !this.dataset.url) return;
          this.loadRecommendations();
        }

        async loadRecommendations() {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = document.createElement('div');
            html.innerHTML = await response.text();
            const recommendations = html.querySelector(`#${this.id}`);
            if (recommendations && recommendations.innerHTML.trim()) {
              this.innerHTML = recommendations.innerHTML;
            }
          } catch (error) {
            return;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
